import React from "react";
import { FormBuilderElementsMappingService } from "../../../../services/builder/form-builder.elements-mapping.service";
import { useFormData } from "../../../../hooks/client/use-form-data";
const FormBuilderFormInterfaceFullName = ({ item, analyticForm, t }) => {
  if (!item) return null;
  const { formData } = useFormData();
  const { div: divArr, legend: legendsArr } = FormBuilderElementsMappingService.getAllSingleElementHTMLTags(item);
  const legend = legendsArr[0];
  const onFocus = (e, input) => {
    analyticForm == null ? void 0 : analyticForm.trackInputFocused(input.name);
  };
  const onBlur = (input) => analyticForm == null ? void 0 : analyticForm.trackInputBlurred(input.name);
  return /* @__PURE__ */ React.createElement("fieldset", { className: item.class }, /* @__PURE__ */ React.createElement("legend", null, t(legend.content || legend.nodeValue)), divArr.map((div) => {
    const { input, label } = FormBuilderElementsMappingService.getSingleElementHTMLTags(div);
    const defaultValue = formData == null ? void 0 : formData[input.name];
    return /* @__PURE__ */ React.createElement("div", { className: div.class, key: input.id }, /* @__PURE__ */ React.createElement("label", { htmlFor: label.for }, t(label.nodeValue)), /* @__PURE__ */ React.createElement(
      "input",
      {
        name: input.name,
        defaultValue,
        type: input.type,
        autoComplete: input.autocomplete,
        onFocus: (e) => onFocus(e, input),
        onBlur: () => onBlur(input),
        placeholder: t(input.placeholder),
        required: input.required,
        id: input.id
      }
    ));
  }));
};
FormBuilderFormInterfaceFullName.displayName = "FormBuilderFormInterfaceFullName";
export default React.memo(FormBuilderFormInterfaceFullName);
